query getLppToken {
  lppInit {
    token
    statusCode
    supplierStatusCode
  }
}
